import React from "react";
import { AnimatedBlock, interpolate, useMountedValue } from "react-uicomp";
import { MdClose } from "react-icons/all";
import { FaCloudDownloadAlt } from "react-icons/all";
import { BASE_URL, FILE_URL } from "../../../config/Config";

const ImageViewer = ({ activeImage, setActiveImage, downloadPath, downloadUrl }) => {
  const mountedValue = useMountedValue(!!activeImage, [0, 1, 0], {
    exitDuration: 200,
  });

  const handleDownload = async () => {
    // prefer direct file URL when available
    const directUrl = downloadUrl ? downloadUrl : downloadPath ? FILE_URL + downloadPath : null;

    if (directUrl) {
      try {
        const res = await fetch(directUrl, { mode: "cors" });
        if (!res.ok) throw new Error("fetch-failed");
        const blob = await res.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        const filename = (downloadPath || directUrl).split("/").pop();
        a.href = url;
        a.download = filename || "image";
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
        return;
      } catch (e) {
        // fallback to backend download route
      }
    }

    if (downloadPath) {
      window.open(BASE_URL + "/download?path=" + downloadPath, "_blank");
    }
  };

  return (
    <>
      {mountedValue(
        (animation, mounted) =>
          mounted && (
            <AnimatedBlock
              className="imageviewer-container"
              style={{
                opacity: animation.value,
              }}>
              <AnimatedBlock
                className="imageviewer"
                style={{
                  transform: interpolate(
                    animation.value,
                    [0, 1],
                    ["scale(0.9)", "scale(1)"],
                  ),
                }}>
                <div className="imageviewer-close">
                  <div
                    className="close-button"
                    onClick={() => setActiveImage(null)}>
                    <MdClose size={24} />
                  </div>
                </div>

                <img key={activeImage} src={activeImage} alt="ActiveGallery" />

                {(downloadPath || downloadUrl) && (
                  <div className="imageviewer-footer">
                    <div
                      className="download-action"
                      role="button"
                      aria-label="Download image"
                      onClick={handleDownload}
                    >
                      <FaCloudDownloadAlt size={18} />
                    </div>
                  </div>
                )}
              </AnimatedBlock>
            </AnimatedBlock>
          ),
      )}
    </>
  );
};

export default ImageViewer;
